import { useEffect } from 'react';

import {
  CampaignStoreItemTypes,
  PeerParticipantsWith__Type,
  useInfiniteListUserParticipants,
} from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';
import { PeerDonationCard } from 'store/Crowdfunding';
import { Button, Center, Loader, LoadingOverlay, Modal, Stack } from 'ui';
import { useDisclosure, useInViewport } from 'ui/Hooks';

const MyFundraisingPagesHistoryContent = () => {
  const navigate = useNavigate();
  const { ref, inViewport } = useInViewport();

  const {
    data: participantData,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteListUserParticipants({
    queryOptions: {
      searches: {
        'store_items.status': { value: 'finished,finishing_required', by: 'in' },
      },
    },
  });

  useEffect(() => {
    if (hasNextPage && inViewport && !isFetchingNextPage) {
      void fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage, inViewport]);

  if (isLoading) {
    return <LoadingOverlay visible />;
  }

  return (
    <Stack>
      {participantData?.pages?.map((page) =>
        page.participants.map((participant) => (
          <PeerDonationCard
            key={participant.uuid}
            campaignPeerInfoCardProps={{
              showCampaignName: true,
              showTeamName: false,
              showCampaignTimeLeft: true,
              wrapDescription: false,
            }}
            onClick={() => {
              navigate(
                `/causes/${participant.store_item.cause_id}/campaigns/${participant.store_item.uuid}/participant-center/participants/${participant.uuid}`
              );
            }}
            heightAuto
            type="participants"
            peer={
              {
                uuid: participant.uuid,
                amount_raised: participant.amount_raised,
                activity: participant.activity,
                goal: participant.goal,
              } as PeerParticipantsWith__Type
            }
            campaign={
              {
                ...participant.store_item,
                __type: participant.store_item.type === 'StoreItems::Athon' ? 'athon' : 'campaign',
              } as CampaignStoreItemTypes
            }
          />
        ))
      )}
      <Center ref={ref}>{isFetchingNextPage && <Loader py="xl" />}</Center>
    </Stack>
  );
};

const MyFundraisingPagesHistoryModal = () => {
  const [opened, { toggle }] = useDisclosure();

  return (
    <>
      <Button variant="subtle" size="sm" onClick={toggle}>
        View History
      </Button>
      <Modal opened={opened} onClose={toggle} title="Fundraising Page History">
        <MyFundraisingPagesHistoryContent />
      </Modal>
    </>
  );
};

export { MyFundraisingPagesHistoryModal };
